import request from '../utils/request';
const querystring = require('querystring')
 
//获取列表数据
export const fetchData = query => { 
    
    var list = request({
        url: 'ersAccount/selectPage.do',
        method: 'post',
        data: querystring.stringify(query),
    }); 
    return list;
};

export const getData = query => {

    var list = request({
        url: 'ersAccount/getData.do',
        method: 'post',
        data: querystring.stringify(query),
    });
    return list;
};
 
//启用-禁用 
export const changeStatus = query => { 
    
    var list = request({
        url: 'ersAccount/changeStatus.do',
        method: 'post',
        data: querystring.stringify(query),
    }); 
    return list;
};
 

export const handDelete = query => {
    var list = request({
        url: 'ersAccount/delete.do',
        method: 'post',
        data: querystring.stringify(query),
    });
    return list;
};
//添加渠道信息
export const saveForm = query => {
    var list = request({
        url: 'ersAccount/insert.do',
        method: 'post',
        data: querystring.stringify(query),
    }); 
    return list;
};


export const changeForm = query => {
    var list = request({
        url: 'ersAccount/update.do',
        method: 'post',
        data: querystring.stringify(query),
    }); 
    return list;
};
export const fetchSelect = query => {
    query.secret = localStorage.getItem('ms_secret');
    var list = request({
        url: 'ersAccount/getListFetch.do',
        method: 'post',
        data: querystring.stringify(query),
    }); 
    return list;
};




